module.exports = __webpack_public_path__ + "static/media/Invited.4046aa97.svg";